const p = () => typeof window < "u", E = () => window.self !== window.top, b = (e) => e instanceof HTMLIFrameElement, M = (e) => {
  window.document.readyState === "complete" ? e() : window.addEventListener("load", e);
}, T = (e, t) => {
  t(), e.addEventListener("load", t);
}, C = (e, t) => {
  var o, i;
  const n = ((o = e.contentWindow) == null ? void 0 : o.document.readyState) === "complete";
  return e.src !== "about:blank" && ((i = e.contentWindow) == null ? void 0 : i.location.href) !== "about:blank" && n ? t() : e.addEventListener("load", t);
}, B = () => ({ offsetSize: 0, checkOrigin: !0, enableLegacyLibSupport: !1 }), k = (e) => {
  try {
    return new URL(e.src).origin === window.location.origin;
  } catch {
    return !1;
  }
}, D = (e) => {
  try {
    const t = new URL(e.src).origin;
    if (t !== "about:blank")
      return t;
  } catch {
  }
  return null;
}, W = (e) => (Object.keys(e).forEach((t) => e[t] === void 0 && delete e[t]), e), L = (e) => {
  const { height: t, width: n } = e.getBoundingClientRect();
  return { height: Math.ceil(t), width: Math.ceil(n) };
}, g = (e, t) => e ? t ? e.querySelector(t) : e.documentElement : null, I = (e, t) => {
  e && (t.bodyPadding && (e.body.style.padding = t.bodyPadding), t.bodyMargin && (e.body.style.margin = t.bodyMargin));
}, h = (e) => e <= 100 ? 100 : e <= 120 ? 1e3 : 1e4, A = () => "[iFrameSizer]ID:0:false:false:32:true:true::auto:::0:false:child:auto:true:::true:::false";
function H(e) {
  if (typeof e.data != "string" || !e.data.startsWith("[iFrameSizer]") || !e.data.endsWith("mutationObserver") && !e.data.endsWith("resizeObserver"))
    return null;
  const [t, n] = e.data.split(":"), r = +n;
  return r > 0 ? r : null;
}
const z = q();
let f = [];
const K = (e, t) => {
  if (!p())
    return [];
  const n = { ...B(), ...W(e ?? {}) }, r = P(t), o = x(n, r);
  return r.map((i) => {
    const s = {
      iframe: i,
      settings: n,
      interactionState: { isHovered: !1 },
      initContext: { isInitialized: !1, retryAttempts: 0 }
    }, a = F(s, o);
    return f.push(s), {
      unsubscribe: () => {
        a(), f = f.filter((d) => d.iframe !== i);
      }
    };
  });
};
function P(e) {
  return typeof e == "string" ? Array.from(document.querySelectorAll(e)).filter(b) : e ? b(e) ? [e] : [] : Array.from(document.getElementsByTagName("iframe"));
}
function x(e, t) {
  if (Array.isArray(e.checkOrigin))
    return e.checkOrigin;
  if (!e.checkOrigin)
    return [];
  const n = [];
  for (const r of t) {
    const o = D(r);
    o && n.push(o);
  }
  return n;
}
function F(e, t) {
  const n = k(e.iframe) ? U(e) : N(e, t), r = $(e);
  return () => {
    n(), r();
  };
}
function N(e, t) {
  const {
    iframe: n,
    initContext: r,
    settings: { checkOrigin: o, enableLegacyLibSupport: i, targetElementSelector: s, bodyPadding: a, bodyMargin: d }
  } = e, u = (c) => {
    var y;
    const S = !o || t.includes(c.origin);
    if (!(!(n.contentWindow === c.source) || !S)) {
      if (((y = c.data) == null ? void 0 : y.type) === "iframe-resized") {
        const { height: l } = c.data;
        l && m({ newHeight: l, registeredElement: e });
        return;
      }
      if (i) {
        const l = H(c);
        l !== null && m({ newHeight: l, registeredElement: e });
        return;
      }
    }
  };
  window.addEventListener("message", u);
  const R = i ? A() : { type: "iframe-child-init", targetElementSelector: s, bodyPadding: a, bodyMargin: d }, w = () => {
    T(n, () => {
      var c;
      return (c = n.contentWindow) == null ? void 0 : c.postMessage(R, "*");
    }), r.retryAttempts++, r.retryTimeoutId = window.setTimeout(w, h(r.retryAttempts));
  };
  return w(), () => window.removeEventListener("message", u);
}
function U(e) {
  const { iframe: t, settings: n } = e, { targetElementSelector: r } = n;
  let o = 0;
  const i = () => {
    const s = g(t.contentDocument, r);
    if (!t.contentDocument || !s)
      return o++, setTimeout(i, h(o));
    I(t.contentDocument, n), z().observe(s);
  };
  return C(t, i), () => {
    const s = g(t.contentDocument, r);
    s && z().unobserve(s), t.removeEventListener("load", i);
  };
}
function $({ iframe: e, interactionState: t }) {
  const n = () => {
    t.isHovered = !0;
  }, r = () => {
    t.isHovered = !1;
  };
  return e.addEventListener("mouseenter", n), e.addEventListener("mouseleave", r), () => {
    e.removeEventListener("mouseenter", n), e.removeEventListener("mouseleave", r);
  };
}
function q() {
  let e = null;
  return () => {
    if (!e) {
      const t = ({ target: n }) => {
        const r = f.find(({ iframe: d }) => d.contentDocument === n.ownerDocument);
        if (!r)
          return;
        const { iframe: o, settings: i } = r, s = g(o.contentDocument, i.targetElementSelector);
        if (!s)
          return;
        const { height: a } = L(s);
        a && m({ newHeight: a, registeredElement: r });
      };
      e = new ResizeObserver((n) => n.forEach(t));
    }
    return e;
  };
}
function m({ registeredElement: e, newHeight: t }) {
  var u;
  const { iframe: n, settings: r, interactionState: o, initContext: i } = e;
  if (i.isInitialized || (i.isInitialized = !0, clearTimeout(i.retryTimeoutId)), ((u = r.onBeforeIframeResize) == null ? void 0 : u.call(r, { iframe: n, settings: { ...r }, observedHeight: t })) === !1)
    return;
  const s = n.getBoundingClientRect(), a = t + r.offsetSize;
  if (n.style.height = `${a}px`, !r.onIframeResize)
    return;
  const d = {
    iframe: n,
    settings: { ...r },
    interactionState: { ...o },
    previousRenderState: { rect: s },
    nextRenderState: { rect: n.getBoundingClientRect() }
  };
  r.onIframeResize(d);
}
const V = G();
let v = !1;
_();
function _() {
  !p() || !E() || window.addEventListener("message", (e) => {
    var t;
    ((t = e.data) == null ? void 0 : t.type) === "iframe-child-init" && M(() => O(e));
  });
}
function O(e, t = 0) {
  const { targetElementSelector: n, bodyPadding: r, bodyMargin: o } = e.data, i = g(document, n);
  if (v || window.parent !== e.source)
    return;
  if (!i)
    return setTimeout(() => O(e, t + 1), h(t));
  I(document, { bodyMargin: o, bodyPadding: r });
  const s = V();
  s.disconnect(), s.observe(i), v = !0;
}
function G() {
  let e = null;
  return () => (e || (e = new ResizeObserver((t) => {
    if (!t[0].target)
      return;
    const { height: n, width: r } = L(t[0].target), o = {
      type: "iframe-resized",
      width: r,
      height: n
    };
    window.parent.postMessage(o, "*");
  })), e);
}
const Q = ({ previousRenderState: e, nextRenderState: t, iframe: n }) => {
  document.activeElement === n && window.scrollBy(0, t.rect.bottom - e.rect.bottom);
};
export {
  K as initialize,
  _ as initializeChildListener,
  Q as updateParentScrollOnResize
};
